import React, { Component } from 'react'
import t from 'tcomb-form'
import logo from '../assets/Logo.png'
import templates from './formTemplate'
import { withFirebase } from 'react-redux-firebase'
import { userActions } from '../actions/user.actions'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { connect } from 'react-redux'
import { styles } from './dockPadStyle'
import Grid from '@material-ui/core/Grid'
import classNames from 'classnames'
import CustomSnackbar from '../components/CustomSnackbar'
import Snackbar from '@material-ui/core/Snackbar'
import SignUpBackground from '../assets/Logo.png'
import { withGetScreen } from 'react-getscreen'
import OutlinedInput from '@material-ui/core/OutlinedInput'

import { ClassNameMap } from '@material-ui/core/styles/withStyles'
import { ThunkDispatch } from 'redux-thunk'
import { History } from 'history'
import parsePhoneNumber from 'libphonenumber-js'
import { TextMaskCustom } from '../components/TextMaskCustom'
import { FormControl, InputLabel, TextField } from '@material-ui/core'

t.form.Form.templates = templates

const SignUpSchema = t.struct({
  first_name: t.String,
  last_name: t.String,
  email: t.String,
  phoneNumber: t.maybe(t.String),
  password: t.String // an optional number
})

const options = {
  fields: {
    password: {
      type: 'password'
    }
  }
}

interface Props {
  isMobile: () => boolean;
  isTable: () => boolean;
  classes: ClassNameMap;
  dispatch: any;
  signUpuser: (email: string, password: string, firstName:string, lastName: string, phoneNumber: string) => Promise<void>;
  history: History;
}

type State = {
  openSnackBar: boolean,
  phoneNumber: string,
  firstName: string, 
  lastName:string, 
  email: string,
  password: string 
}

class SignUpScreen extends Component<Props, State> {
  state = {
    openSnackBar: false,
    phoneNumber: "",
    lastName:"",
    firstName: "",
    email: "",
    password: ""
  }

  onSubmit(evt: any) {
    evt.preventDefault()

    const { firstName, lastName, email, password, phoneNumber } = this.state

    const parsedPhoneNumber = parsePhoneNumber(phoneNumber)
    if(!!parsedPhoneNumber && parsedPhoneNumber.number != '+1' && !parsedPhoneNumber.isValid()) {
      this.setState({
        openSnackBar: true
      })
      return
    }

    if (!!firstName && !!lastName && !!password && !!email) {
      const { signUpuser, history } = this.props
      signUpuser(email, password, firstName, lastName, phoneNumber).then(() => {
        history.push('/')
      })
      
    } else {
      this.setState({
        openSnackBar: true
      })
    }
  }

  handleSnackbarClose = () => {
    this.setState({ openSnackBar: false })
  }

  renderRightSide = () => {
    const { classes } = this.props

    if (this.props.isMobile()) return

    return (
      <div
        className={classNames(
          classes.CenterContainer,
          classes.rightBigForm
        )}>
        <Typography style={{ color: '#fff' }} variant='display3'>
          DockPad
        </Typography>
      </div>
    )
  }

  isValidNumber(phoneNumber: string) {

    if(!phoneNumber) return false

    const parsedNumber = parsePhoneNumber(phoneNumber)


    if(!parsedNumber) return false

    return parsedNumber.isValid()
  }

  onFirstNameChange =(event) => {

    this.setState({
      firstName: event.target.value
    })
  }


  onLastNameChange =(event) => {

    this.setState({
      lastName: event.target.value
    })
  }


  onEmailChange =(event) => {

    this.setState({
      email: event.target.value
    })
  }


  onPasswordChange =(event) => {

    this.setState({
      password: event.target.value
    })
  }

  render() {
    const { classes, isMobile } = this.props
    const leftWidth = isMobile() ? "100%" : "50%"

    const fullLength = !!this.state.phoneNumber ? this.state.phoneNumber.length  : 0


    const isFullLength = fullLength == 12


    return (
      <form style={{ height: '100%', display: 'flex', width: '100%' }} onSubmit={this.onSubmit.bind(this)}>
        <Snackbar
          open={this.state.openSnackBar}
          autoHideDuration={2000}
          onClose={this.handleSnackbarClose}>
          <CustomSnackbar
            onClose={this.handleSnackbarClose}
            variant='error'
            message='Sign Up Error!'
          />
        </Snackbar>

        <div
          style={{ width: leftWidth }}
          className={classNames(
            classes.CenterContainer,
            classes.leftBigForm
          )}>
          
          <TextField onChange={this.onFirstNameChange} fullWidth={true} style={{marginTop: 8, marginBottom: 8, marginLeft: 32, paddingRight: 32}} label="First Name" variant="outlined" />
          <TextField onChange={this.onLastNameChange}fullWidth={true} style={{marginTop: 8, marginBottom: 8, marginLeft: 32, paddingRight: 32}}  label="Last Name" variant="outlined" />
          <TextField onChange={this.onEmailChange} fullWidth={true} style={{marginTop: 8, marginBottom: 8, marginLeft: 32, paddingRight: 32}} label="Email" variant="outlined"  />

          <FormControl               style={{marginTop: 8, marginBottom: 8, paddingLeft: 16, paddingRight: 16}}   fullWidth={true} variant="outlined">    
            <InputLabel style={{marginLeft: 16}} htmlFor
            ="outlined-adornment-password">Phone Number (Optional)</InputLabel>
            <OutlinedInput
              labelWidth={180}
              onChange={async (event) => {

                const phoneNumber:string = !!parsePhoneNumber(event.target.value) ? parsePhoneNumber(event.target.value).number : '+1'
                this.setState({
                  phoneNumber
                })

              }}
              error={!this.isValidNumber(this.state.phoneNumber) && isFullLength}
              id="formatted-text-mask-input"
              inputComponent={TextMaskCustom}
            />
          </FormControl>
          <TextField onChange={this.onPasswordChange} fullWidth={true} style={{marginTop: 8, marginBottom: 8, marginLeft: 32, paddingRight: 32}} label="Password" variant="outlined" />

          <Button variant='outlined' color='primary' type='submit'>
            {' '}Sign Up{' '}
          </Button>
        </div>

        {this.renderRightSide()}
      </form>
    )
  }
}

const mapStateToProps = (state: any) => ({

});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

  return {
    signUpuser: (email: string, password:string, firstName:string, lastName:string, phoneNumber: string) => dispatch(userActions.signUpUser(email, password, firstName, lastName, phoneNumber))
  }
};
export default compose(
  withFirebase,
  withRouter,
  withGetScreen,
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps),

)(SignUpScreen)



// WEBPACK FOOTER //
// ./src/containers/SignUpScreen.tsx